<div class="flex items-center gap-1 w-fit" [matTooltip]="tooltip()">
  @for (filled of stars(); track $index) {
    <svg
      class="ui-star w-6 h-6 shrink-0"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        [class.ui-star--filled]="filled"
        d="M12 0L14.6942 8.2918H23.4127L16.3593 13.4164L19.0534 21.7082L12 16.5836L4.94658 21.7082L7.64074 13.4164L0.587322 8.2918H9.30583L12 0Z"
        [attr.fill]="filled ? '#EBC603' : '#003255'"
        [attr.fill-opacity]="filled ? 1 : 0.08"
      />
    </svg>
  }
</div>
